module.exports = __webpack_public_path__ + "c7de68d4bcd79eb1dd180c6ed800c4fb.png";